export const ENVIORNMENTS = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  SANDBOX: "sandbox",
}

export const LANGS = [
  { languageId: 1, name: "Español", code: "es" },
  { languageId: 2, name: "English", code: "en" },
  { languageId: 3, name: "Français", code: "fr" },
  { languageId: 4, name: "Chinese (Simplified): 简体中文", code: "zh-Hans" },
  { languageId: 5, name: "Chinese (Traditional): 繁體中文", code: "zh-CN" },
  { languageId: 6, name: "Português (Brasil)", code: "pt-BR" },
  { languageId: 7, name: "Mohawk", code: "moh" },
  { languageId: 8, name: "Romanian: Română", code: "ro" },
  { languageId: 9, name: "Slovak: Slovenčina", code: "sk" },
  { languageId: 10, name: "Slovenian: Slovenščina", code: "sl" },
  { languageId: 11, name: "Swedish: Svenska", code: "sv" },
  { languageId: 12, name: "Turkish: Türkçe", code: "tr" },
  { languageId: 13, name: "Lithuanian: Lietuvių", code: "lt" },
  { languageId: 14, name: "Norwegian: Norsk", code: "no" },
  { languageId: 15, name: "Polish: Polski", code: "pl" },
  { languageId: 16, name: "Dutch: Nederlands", code: "nl" },
  { languageId: 17, name: "Estonian: Eesti", code: "et" },
  { languageId: 18, name: "Finnish: Suomi", code: "fi" },
  { languageId: 19, name: "Greek: Ελληνικά", code: "el" },
  { languageId: 20, name: "Hungarian: Magyar", code: "hu" },
  { languageId: 21, name: "Indonesian: Bahasa Indonesia", code: "id" },
  { languageId: 22, name: "Latvian: Latviešu", code: "lv" },
  { languageId: 23, name: "Czech: Čeština", code: "cs" },
  { languageId: 24, name: "Danish: Dansk", code: "da" },
  { languageId: 25, name: "Bulgarian: Български", code: "bg" },
  { languageId: 26, name: "Italian: Italiano", code: "it" },
  { languageId: 27, name: "Portuguese: Português", code: "pt-PT" },
  { languageId: 28, name: "German: Deutsch", code: "de" },
  { languageId: 29, name: "Japanese: 日本語", code: "ja" },
  { languageId: 30, name: "Korean: 한국어", code: "ko" },
  { languageId: 31, name: "Russian: Русский", code: "ru" },
  { languageId: 32, name: "Ukrainian: Українська", code: "uk" },
  { languageId: 33, name: "Arabic: العربية", code: "ar" },
  { languageId: 34, name: "Bengali: বাংলা", code: "bn" },
  { languageId: 35, name: "Gujarati: ગુજરાતી", code: "gu" },
  { languageId: 36, name: "Hindi: हिन्दी", code: "hi" },
  { languageId: 37, name: "Punjabi: ਪੰਜਾਬੀ", code: "pa" },
  { languageId: 38, name: "Somali: Soomaali", code: "so" },
  { languageId: 39, name: "Tagalog: Tagalog", code: "fil" },
  { languageId: 40, name: "Tamil: தமிழ்", code: "ta" },
  { languageId: 41, name: "Telugu: తెలుగు", code: "te" },
  { languageId: 42, name: "Urdu: اردو", code: "ur" },
  { languageId: 43, name: "Vietnamese: Tiếng Việt", code: "vi" },
  { languageId: 44, name: "Yue (Cantonese): 粵語", code: "zh-HK" },
  { languageId: 45, name: "Farsi: فارسی", code: "fa" },
  { languageId: 46, name: "Kurdish: Kurdî", code: "ku" },
  { languageId: 47, name: "Pashto: پښتو", code: "ps" },
]

export const ANCHOR_ORIGIN = {
  BOTTOM_RIGHT: { vertical: "bottom", horizontal: "right" },
  BOTTOM_LEFT: { vertical: "bottom", horizontal: "left" },
  TOP_RIGHT: { vertical: "top", horizontal: "right" },
  TOP_LEFT: { vertical: "top", horizontal: "left" },
}

export const QUILL_TOOLBAR = [
  ["bold", "italic", "underline", "strike", "blockquote"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
]

export const QUILL_FORMATS = [
  "font",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "header",
]

export const DEVICE_TYPES = {
  WEB: 1,
  IPADOS: 2,
  IOS: 3,
  ANDROIDTABLET: 4,
  ANDROID: 5,
  WEB_TEACHER: 6,
}

export const SCREEN_TYPES = {
  MISSIONS: "missions",
  CREATE_ACCOUNT: "create_account",
  DEFAULT: "default",
  CONTENT: "content",
}

export const SCREEN_ID = {
  1: {
    missions: 61,
    create_account: 67,
    default: 73,
    content: 7,
    placement: 90,
    games: 104,
  },
  2: {
    missions: 62,
    create_account: 68,
    default: 74,
    content: 78,
    games: 96,
  },
  3: {
    missions: 63,
    create_account: 69,
    default: 75,
    content: 79,
    games: 97,
  },
  4: {
    missions: 64,
    create_account: 70,
    default: 76,
    content: 80,
    games: 98,
  },
  5: {
    missions: 65,
    create_account: 71,
    default: 77,
    content: 81,
    games: 99,
  },
  6: {
    missions: 61,
    create_account: 67,
    default: 73,
    content: 7,
    placement: 90,
    games: 105,
  },
}

export const WEB_APP_VERSION = process.env.REACT_APP_VERSION

export const SMASH_SESSION = "smashSession"

export const LOCAL_STORAGE_PREFIX = "react_smash_"

export const SUPPORT_TYPES = {
  TEACHER: 10,
}

export const USER_TYPES = {
  SYSADMIN: 1,
  TEACHER: 6,
  STUDENT: 7,
  SCHOOL_DIRECTOR: 10,
  SCHOOL_ADMINISTRATOR: 11,
}

export const STAFF_TYPES = [
  USER_TYPES.SCHOOL_DIRECTOR,
  USER_TYPES.SCHOOL_ADMINISTRATOR,
  USER_TYPES.SYSADMIN,
]

export const GROUP_TYPES = {
  ELEMENTARY_NEWCOMERS_REGULAR_CLASS: 1,
  ELEMENTARY_NEWCOMERS_STAND_ALONE: 2,
  ELEMENTARY_NEWCOMERS_ORAL_WORKSHOP: 3,
  ELEMENTARY_REGULAR_CLASS: 4,
  ELEMENTARY_STAND_ALONE: 5,
  ELEMENTARY_ORAL_WORKSHOP: 6,
  SECONDARY_NEWCOMERS_REGULAR_CLASS: 7,
  SECONDARY_NEWCOMERS_STAND_ALONE: 8,
  SECONDARY_NEWCOMERS_ORAL_WORKSHOP: 9,
  SECONDARY_REGULAR_CLASS: 10,
  SECONDARY_STAND_ALONE: 11,
  SECONDARY_ORAL_WORKSHOP: 12,
  HIGHER_EDUCATION_REGULAR_CLASS: 13,
  HIGHER_EDUCATION_STAND_ALONE: 14,
  HIGHER_EDUCATION_ORAL_WORKSHOP: 15,
}

export const ELEMENTARY_TO_REGULAR = {
  [GROUP_TYPES.ELEMENTARY_NEWCOMERS_REGULAR_CLASS]:
    GROUP_TYPES.SECONDARY_NEWCOMERS_REGULAR_CLASS,
  [GROUP_TYPES.ELEMENTARY_NEWCOMERS_STAND_ALONE]:
    GROUP_TYPES.SECONDARY_NEWCOMERS_STAND_ALONE,
  [GROUP_TYPES.ELEMENTARY_NEWCOMERS_ORAL_WORKSHOP]:
    GROUP_TYPES.SECONDARY_NEWCOMERS_ORAL_WORKSHOP,
  [GROUP_TYPES.ELEMENTARY_REGULAR_CLASS]: GROUP_TYPES.SECONDARY_REGULAR_CLASS,
  [GROUP_TYPES.ELEMENTARY_STAND_ALONE]: GROUP_TYPES.SECONDARY_STAND_ALONE,
  [GROUP_TYPES.ELEMENTARY_ORAL_WORKSHOP]: GROUP_TYPES.SECONDARY_ORAL_WORKSHOP,
}

export const REGULARS_GROUPS_TYPES = [
  GROUP_TYPES.ELEMENTARY_NEWCOMERS_REGULAR_CLASS,
  GROUP_TYPES.ELEMENTARY_REGULAR_CLASS,
  GROUP_TYPES.SECONDARY_NEWCOMERS_REGULAR_CLASS,
  GROUP_TYPES.SECONDARY_REGULAR_CLASS,
  GROUP_TYPES.HIGHER_EDUCATION_REGULAR_CLASS,
]

export const STAND_ALONE_GROUPS_TYPES = [
  GROUP_TYPES.ELEMENTARY_NEWCOMERS_STAND_ALONE,
  GROUP_TYPES.ELEMENTARY_STAND_ALONE,
  GROUP_TYPES.SECONDARY_NEWCOMERS_STAND_ALONE,
  GROUP_TYPES.SECONDARY_STAND_ALONE,
  GROUP_TYPES.HIGHER_EDUCATION_STAND_ALONE,
]

export const ENABLE_ACCOUNT_SETUPS_AUDIOS = false

export const NOTIFICATION_TYPES = {
  SMASH_GAME: "SmashGame",
  INDEPENDENT_WORK: "IndependentWork",
  INDEPENDENT_WORK_TEAM: "IndependentWorkTeams",
  REAL_TIME_INSTRUCTION_TEAM: "RealTimeInstructionTeams",
}

export const SURVEY_QUESTION_TYPES = {
  STARS: 2,
  YES_NO: 1,
  OPEN: 3,
}

export const TEACHER_SUPPORTED_LANGUAGES = [1, 2, 3]
